import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getCargos(companyId, query) {
	return dataTransferWrap(
		ModulesMap.CARGOS,
		dtConfig[ModulesMap.CARGOS].getCargos,
		{
			urlParams: {
				companyId,
			},
			params: query,
		}
	)
}

function getCargo(companyId, cargoId) {
	return dataTransferWrap(
		ModulesMap.CARGOS,
		dtConfig[ModulesMap.CARGOS].getCargo,
		{
			urlParams: {
				companyId,
				cargoId,
			},
		}
	)
}

function createCargo(companyId, payload) {
	return dataTransferWrap(
		ModulesMap.CARGOS,
		dtConfig[ModulesMap.CARGOS].createCargo,
		{
			urlParams: {
				companyId,
			},
			...payload,
		}
	)
}


function putCargo(companyId, cargoId, payload) {
	return dataTransferWrap(
		ModulesMap.CARGOS,
		dtConfig[ModulesMap.CARGOS].putCargo,
		{
			urlParams: {
				companyId,
				cargoId,
			},
			...payload,
		}
	)
}

function patchCargo(companyId, cargoId, payload) {
	return dataTransferWrap(
		ModulesMap.CARGOS,
		dtConfig[ModulesMap.CARGOS].patchCargo,
		{
			urlParams: {
				companyId,
				cargoId,
			},
			...payload,
		}
	)
}

function deleteCargo(companyId, cargoId) {
	return dataTransferWrap(
		ModulesMap.CARGOS,
		dtConfig[ModulesMap.CARGOS].deleteCargo,
		{
			urlParams: {
				companyId,
				cargoId,
			},
		}
	)
}

function getCargoPreview(companyId, cargoId) {
	return dataTransferWrap(
		ModulesMap.CARGOS,
		dtConfig[ModulesMap.CARGOS].getCargoPreview,
		{
			urlParams: {
				companyId,
				cargoId,
			},
		}
	)
}

function getCargoPopup(companyId, cargoId) {
	return dataTransferWrap(
		ModulesMap.CARGOS,
		dtConfig[ModulesMap.CARGOS].getCargoPopup,
		{
			urlParams: {
				companyId,
				cargoId,
			},
		}
	)
}

export default {
	getCargos,
	getCargo,
	createCargo,
	putCargo,
	patchCargo,
	deleteCargo,
	getCargoPreview,
	getCargoPopup,
}

